import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/bootstrap.css";
import { useHistory } from "react-router-dom";
import { getTObjectValue, getTValue } from "../other/label";

function DuplicateDialog(props) {
    const { t, i18n } = useTranslation();
    let message;
    let messageNep;

    if (props.errorCode?.startsWith("duplicate_data_ctzn")) {
        message = "Customer citizenship matched with the following data. Please visit the DP for further processing!!";
        messageNep = "";
    }

    if (props.errorCode?.startsWith("duplicate_data_nid")) {
        message = "Customer National Identification Number matched with the following data. Please visit the KYC Agent for further processing!!";
        messageNep = "";
    } if (props.errorCode?.startsWith("duplicate_data_minor")) {
        message = "Customer minor details matched i.e. Name or Date of Birth or Birth Certificate Number with the following data. Please visit the DP for further processing!!";
        messageNep = "";
    }
    if (props.errorCode?.startsWith("duplicate_data_comp")) {
        message = "Company detials matched i.e. Customer Name or Pan or Registration Number with the following data. Please visit the DP for further processing!!";
        messageNep = "";
    }
    if (props.errorCode?.startsWith("duplicate_data_boid")) {
        message = "Boid detials matched with the following data. Please visit the DP for further processing!!";
        messageNep = "";
    }
    if (props.errorCode?.startsWith("duplicate_data_bio")) {
        message = "Biometrics detials matched with the following data. Please visit the DP for further processing!!";
        messageNep = "";
    }

    return (
        <Dialog
            header={"Data Matched!!"}
            visible={props.visible}
            style={{ width: "50%", height: "400px" }}
            footer={
                <>
                    <Button
                        icon="pi pi-check"
                        label="Ok"
                        onClick={() => {
                            props.onHide();
                        }}
                    />
                </>
            }
            onHide={props.onHide}
        >
            <div className="p-grid p-fluid">
                <br />
                <h3 style={{ color: 'red', padding: '3px' }}>
                    {getTValue(i18n, message, messageNep)}
                </h3>
                <br />
                <DataTable value={props.duplicateList} dataKey="bank">
                    <Column
                        header={"Temporary Kyc ID"}
                        field="tempKycId"
                    ></Column>
                    <Column
                        header={"Permanent Kyc ID"}
                        field="permKycId"
                    ></Column>
                    <Column
                        header={"DP Name"}
                        field="orgName"
                    ></Column>

                </DataTable>

            </div>
        </Dialog>
    );
}
export default DuplicateDialog;
